import { render, staticRenderFns } from "./tabel-list.vue?vue&type=template&id=56606bb9&scoped=true"
import script from "./tabel-list.vue?vue&type=script&lang=js"
export * from "./tabel-list.vue?vue&type=script&lang=js"
import style0 from "./tabel-list.vue?vue&type=style&index=0&id=56606bb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56606bb9",
  null
  
)

export default component.exports